var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2783_49002)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2783_49002",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H18V18H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2783_49002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7461 7.94531V8.47266M13.7461 8.47266C13.7461 9.34639 13.0378 10.0547 12.1641 10.0547C11.2903 10.0547 10.582 9.34639 10.582 8.47266M13.7461 8.47266C13.7461 9.34639 14.4544 10.0547 15.3281 10.0547C16.2019 10.0547 16.9102 9.34639 16.9102 8.47266V7.94531V5.83594H1.08984V7.94531V8.47266C1.08984 9.34639 1.79814 10.0547 2.67188 10.0547C3.54561 10.0547 4.25391 9.34639 4.25391 8.47266M10.582 8.47266V7.94531M10.582 8.47266C10.582 9.34639 9.87374 10.0547 9 10.0547C8.12626 10.0547 7.41797 9.34639 7.41797 8.47266M7.41797 8.47266V7.94531M7.41797 8.47266C7.41797 9.34639 6.70968 10.0547 5.83594 10.0547C4.9622 10.0547 4.25391 9.34639 4.25391 8.47266M4.25391 8.47266V7.94531",
    stroke: "#007FFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.08984 5.83594L4.25391 2.67188H13.7461L16.9102 5.83594",
    stroke: "#007FFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8555 9.96465V17.4727H2.14453V9.96465",
    stroke: "#007FFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25391 17.4727V12.1641H7.41797V17.4727",
    stroke: "#007FFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7461 14.2734H9.52734V12.1641H13.7461V14.2734Z",
    stroke: "#007FFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25391 2.67188V0.527344H13.7461V2.67188",
    stroke: "#007FFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2783_49002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmeIcon);
export default __webpack_public_path__ + "static/media/smeIcon.343d97da333f33ca928bd9d1c8a26e39.svg";
export { ForwardRef as ReactComponent };